import React from "react";
import {Button} from "react-bootstrap";
import {withNamespaces} from "react-i18next";

/**
 *
 * @param t
 * @param type true = update, false = create
 * @param icon
 * @param label
 * @param validation
 * @param submit
 * @returns {*}
 * @constructor
 */
const SubmitButton = ({t, type, icon = null, label = null, validation = null, submit }) => {

    const classButton = type ?
        "primary":
        "success";

    const classIcon = icon ?
        icon:
        type ?
            "fas fa-edit":
            "fas fa-plus";

    const labelText = label ?
        label:
        type ?
            "edit":
            "create";

    return (
        <Button type={"submit"} variant={classButton}>
            <i className={classIcon}> </i> {t(labelText)}
        </Button>
    )
};
export default withNamespaces()(SubmitButton);
